import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        iconFeature: {
          module: () => import('./icon.module').then((m) => m.IconModule),
        },
      }
    })
  ]
})
export class IconFeatureModule {}
